import { Message, RadioButton, spacing } from 'component-library';
import { useTranslation } from 'react-i18next';
import { useProfileV2 } from 'core/lib/Profile';
import { type ForMeProps } from '../../types';
import SelectedUser from './SelectedUser';
import SelectHierarchy from './SelectHierarchy';
import { ORDER_FOR_ME_VALUE } from './constants';
import { NoValidCostCenter } from './NoValidCostCenter';

const ForMe = ({
  active,
  selectedHierarchy,
  getSelectedHierarchyDetailsFromDwKey,
  handleSelectHierarchy,
  handleSelectUsersCategory,
  selectedUserId,
  getUserDetailsFromId,
  hierarchies,
  disabled,
  hasAvailableCostCenters,
  allowedToPurchaseSubscription,
  subscriptionType,
}: ForMeProps) => {
  const { t } = useTranslation();
  const { profile } = useProfileV2();

  return (
    <>
      <RadioButton
        checked={active}
        disabled={disabled}
        label={t('subscription.checkout.step1.radio1.label')}
        value={ORDER_FOR_ME_VALUE}
        description={t('subscription.checkout.step1.radio1.description', {
          email: profile?.email,
        })}
        onChange={handleSelectUsersCategory}
      />
      {active && selectedUserId && hierarchies && hierarchies.length > 0 && (
        <SelectedUser
          user={getUserDetailsFromId(selectedUserId)}
          hierarchy={getSelectedHierarchyDetailsFromDwKey(selectedHierarchy)}
        />
      )}
      {active && hierarchies && (
        <SelectHierarchy
          hierarchies={hierarchies}
          onChange={handleSelectHierarchy}
          selected={selectedHierarchy}
        />
      )}
      {active &&
        selectedUserId &&
        selectedHierarchy &&
        selectedHierarchy.length > 0 &&
        hierarchies &&
        !hasAvailableCostCenters && <NoValidCostCenter />}
      {active &&
        hierarchies &&
        hierarchies.length === 0 &&
        !disabled &&
        allowedToPurchaseSubscription && (
          <div style={{ margin: `${spacing.xxsmall} 0 ${spacing.xsmall} 0` }}>
            <Message
              description={t(
                subscriptionType === 'CO2'
                  ? 'co2_impact.checkout.errors.no.unsubscribed.hierarchies.myself'
                  : 'subscription.checkout.errors.no.unsubscribed.hierarchies.myself.csrd',
              )}
            />
          </div>
        )}
      {active && !allowedToPurchaseSubscription && (
        <div style={{ margin: `${spacing.xxsmall} 0 ${spacing.xsmall} 0` }}>
          <Message
            severity="error"
            title={t('subscription.checkout.errors.not.allowed.to.purchase.subscription')}
            description={t(
              'subscription.checkout.errors.not.allowed.to.purchase.subscription.description',
            )}
          />
        </div>
      )}
    </>
  );
};

export default ForMe;
